import React from 'react';
import PropTypes from 'prop-types';
import ScriptedResultTable from './VerifyScriptedResults';

/**
 * Main result content dispatcher — renders the appropriate table based on resultType.
 *
 * @param {Object} props
 * @param {Object} props.verifyResult - The structured result object from a verify strategy
 */
export default function VerifyResultContent({ verifyResult }) {
    if (!verifyResult?.resultType || !verifyResult?.resultData) {
        return null;
    }

    switch (verifyResult.resultType) {
        case 'web':
        case 'scripted':
            return <ScriptedResultTable resultData={verifyResult.resultData} />;
        case 'voip':
            return null;
        default:
            return null;
    }
}

VerifyResultContent.propTypes = {
    verifyResult: PropTypes.shape({
        resultType: PropTypes.string,
        resultData: PropTypes.object,
    }),
};

VerifyResultContent.defaultProps = {
    verifyResult: null,
};
